import request from '@/utils/request'
// import { Notification } from 'element-ui'

/**
 * 获取所有角色
 */
export function getAllRoles() {
  return request({
    url: '/sysRole/getAll',
    method: 'post'
  })
}

/**
 * 查询用户已有角色
 * @param {string} 用户id
 */
export function queryHavedRoles(id) {
  return request({
    url: `/sysRole/byIdAll/${id}`,
    method: 'post'
  })
}

export function listMenu(id) {
  return request({
    url: `/sysRole/listMenu/${id}`,
    method: 'post'
  })
}

export function modify(data) {
  return request({
    url: '/sysRole/modify',
    method: 'post',
    data
  })
}

export function editStatus(data) {
  return request({
    url: '/sysRole/editStatus',
    method: 'post',
    data
  })
}
